import * as bootstrap from "bootstrap";

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

const menutoggle = document.querySelector('.menu-toggle');
const titlebar = document.querySelector('.titlebar');

if(menutoggle && titlebar) {
    let r = document.querySelector(":root");
    let titlebarHeight = Math.ceil(
        Math.max(
            menutoggle.offsetHeight,
            titlebar.offsetHeight
        )
    );

    r.style.setProperty("--titlebar-height", titlebarHeight + "px");
}

const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
[...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl));


document.querySelectorAll('div.showOnClick').forEach((element) => {
    element.querySelectorAll('input').forEach((input) => {
        input.removeAttribute('required');
        input.removeAttribute('aria-required');
    });
    element.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        element.querySelector('.showOnClickContainer').classList.toggle('d-none');
    })
})
